namespace $.$$ {

	export class $shm_hitalama_app_fullscreen extends $.$shm_hitalama_app_fullscreen {

		_fullscreen_content_dom?: HTMLElement
		_fullscreen_content_doms: HTMLElement[] = []
		_fullscreen_style_backup = new Map< HTMLElement, Record< string, string > >()
		_group_back_dom?: HTMLElement
		_group_fill_dom?: HTMLElement
		_group_scroll_dom?: HTMLElement
		_group_space_dom?: HTMLElement
		_group_wheel_doms = new WeakSet< HTMLElement >()
		_group_wheel_disposers: (()=> void)[] = []
		_fullscreen_zoom_doms = new Set< HTMLElement >()

		fullscreen_panel_width() {
			return 40
		}

		fullscreen_zoom() {
			return this.overlay_panel().fullscreen_zoom()
		}

		@ $mol_action
		hide_fullscreen() {
			this.restore_content_zoom()
			this._fullscreen_content_dom?.removeAttribute( 'popover' )
			if( this._fullscreen_content_dom ) this.restore_dom_style( this._fullscreen_content_dom )
			this._fullscreen_content_dom = undefined
			this.hide_group_fullscreen()

			this.overlay_panel().hide_popover()
		}

		hide_group_fullscreen() {
			this.restore_content_zoom()
			for( const dispose of this._group_wheel_disposers ) dispose()
			this._group_wheel_disposers = []
			this._group_wheel_doms = new WeakSet

			for( const dom of this._fullscreen_content_doms ) {
				dom.removeAttribute( 'popover' )
				this.restore_dom_style( dom )
			}

			this._fullscreen_content_doms = []
			this.hide_group_back()
		}

		hide_group_back() {
			this._group_back_dom?.removeAttribute( 'popover' )
			this._group_fill_dom?.removeAttribute( 'popover' )
			this._group_scroll_dom?.removeAttribute( 'popover' )
			if( this._group_back_dom ) this.restore_dom_style( this._group_back_dom )
			if( this._group_fill_dom ) this.restore_dom_style( this._group_fill_dom )
			if( this._group_scroll_dom ) this.restore_dom_style( this._group_scroll_dom )
			if( this._group_space_dom ) this.restore_dom_style( this._group_space_dom )
			this._group_back_dom = undefined
			this._group_fill_dom = undefined
			this._group_scroll_dom = undefined
			this._group_space_dom = undefined
		}

		@ $mol_mem
		fullscreen_widget_toggle_auto() {
			const ref_str = this.$.$mol_state_arg.value( 'fullscreen_widget' )
			const application = this.application_id()
			if( application && !ref_str ) {
				// The slot is mounted by this view before auto runs. Keep the host's
				// full-viewport background, just as with widget content popovers.
				this.show_fullscreen_content( this.Application().dom_node() as HTMLElement )
				return application
			}
			if( !ref_str ) {
				this.hide_fullscreen()
				return
			}

			const ref = new $giper_baza_link( ref_str )
			const widget = this.$.$giper_baza_glob.Pawn( ref, $shm_hitalama_map_widget )
			const needs_dom_slot = this.fullscreen_needs_dom_slot( ref_str )

			if( needs_dom_slot ) {
				const ids = this.fullscreen_ids()
				if( !ids.includes( ref_str ) ) this.fullscreen_ids( [ ...ids, ref_str ] )
			}

			if( this.widget_has_fullscreen_children( widget ) && !needs_dom_slot ) {
				const doms = this.group_fullscreen_doms( ref_str )
				if( doms.some( dom => !dom.isConnected ) ) {
					this.$.$mol_state_time.now( 100 )
					return ref_str
				}

				const content_changed = !this.doms_equal( this._fullscreen_content_doms, doms )
				if( content_changed ) {
					this.hide_group_fullscreen()
					this.group_scroll_pos( [ 0, 0 ] )
				}
				this._fullscreen_content_dom?.removeAttribute( 'popover' )
				this._fullscreen_content_dom = undefined

				this.show_group_back( widget )
				this._fullscreen_content_doms = doms
				for( const dom of doms ) {
					if( dom.popover !== 'manual' ) dom.popover = 'manual'
					if( !dom.matches( ':popover-open' ) ) dom.showPopover()
				}

				this.overlay_panel().show_popover( content_changed )
				return ref_str
			}

			const content = needs_dom_slot
				? this.fullscreen_content( ref_str )
				: this.fullscreen_content_view( ref_str )
			const dom = content.dom_tree() as HTMLElement

			if( !dom.isConnected ) {
				this.$.$mol_state_time.now( 100 )
				return ref_str
			}

			this.show_fullscreen_content( dom, widget.color() )
			return ref_str
		}

		show_fullscreen_content( dom: HTMLElement, color = '' ) {
			const content_changed = this._fullscreen_content_dom !== dom
			if( content_changed ) {
				this.hide_group_fullscreen()
				this._fullscreen_content_dom?.removeAttribute( 'popover' )
				if( this._fullscreen_content_dom ) this.restore_dom_style( this._fullscreen_content_dom )
				this._fullscreen_content_dom = dom
			}

			const zoom = this.fullscreen_zoom()
			const viewport = this.$.$mol_window.size()
			const width = `${ Math.max( 0, viewport.width - this.fullscreen_panel_width() ) / zoom }px`
			const height = `${ viewport.height / zoom }px`
			this.apply_dom_style( dom, {
				position: 'fixed',
				inset: '0 auto auto 0',
				transition: 'none',
				width,
				minWidth: width,
				maxWidth: width,
				height,
				minHeight: height,
				maxHeight: height,
				boxSizing: 'border-box',
				margin: '0',
				zoom: '1',
				transformOrigin: '0 0',
				transform: `scale(${ zoom })`,
				userSelect: 'text',
				color: color || 'var(--mol_theme_text)',
				overflow: 'auto',
			} )
			this.fullscreen_size_apply( dom, width, height )
			if( dom.popover !== 'manual' ) dom.popover = 'manual'
			if( !dom.matches( ':popover-open' ) ) dom.showPopover()

			this.overlay_panel().show_popover( content_changed )

		}

		doms_equal( left: readonly HTMLElement[], right: readonly HTMLElement[] ) {
			if( left.length !== right.length ) return false

			for( let i = 0; i < left.length; i++ ) {
				if( left[i] !== right[i] ) return false
			}

			return true
		}

		fullscreen_size_apply( dom: HTMLElement, width: string, height: string ) {
			dom.style.setProperty( 'box-sizing', 'border-box', 'important' )
			for( const [ key, value ] of Object.entries({ width, minWidth: width, maxWidth: width, height, minHeight: height, maxHeight: height }) ) {
				dom.style.setProperty( this.style_property_name( key ), value, 'important' )
			}
		}

		style_property_name( key: string ) {
			return key.replace( /[A-Z]/g, letter => `-${ letter.toLowerCase() }` )
		}

		show_group_back( widget: $shm_hitalama_map_widget ) {
			const zoom = this.fullscreen_zoom()
			const root_width = this.widget_width( widget ) * zoom
			const root_height = this.widget_height( widget ) * zoom
			const viewport_width = this.$.$mol_dom_context.window.innerWidth - this.fullscreen_panel_width()
			const viewport_height = this.$.$mol_dom_context.window.innerHeight
			const content_width = Math.max( viewport_width, root_width )
			const content_height = Math.max( viewport_height, root_height )
			const shift_left = Math.max( 0, ( viewport_width - root_width ) / 2 )
			const shift_top = Math.max( 0, ( viewport_height - root_height ) / 2 )

			const back = this.Group_back().dom_tree() as HTMLElement
			this._group_back_dom = back
			this.apply_dom_style( back, {
				position: 'fixed',
				inset: `0 ${ this.fullscreen_panel_width() }px 0 0`,
				width: 'auto',
				height: '100vh',
				margin: '0',
				padding: '0',
				border: 'none',
				outline: 'none',
				transition: 'none',
				backgroundColor: 'var(--mol_theme_back)',
			} )
			if( back.popover !== 'manual' ) back.popover = 'manual'
			if( !back.matches( ':popover-open' ) ) back.showPopover()

			const scroll = this.Group_scroll().dom_tree() as HTMLElement
			this._group_scroll_dom = scroll
			this.apply_dom_style( scroll, {
				position: 'fixed',
				inset: `0 ${ this.fullscreen_panel_width() }px 0 0`,
				width: 'auto',
				height: '100vh',
				margin: '0',
				padding: '0',
				border: 'none',
				outline: 'none',
				transition: 'none',
				overflow: 'auto',
				backgroundColor: 'var(--mol_theme_back)',
			} )
			if( scroll.popover !== 'manual' ) scroll.popover = 'manual'
			if( !scroll.matches( ':popover-open' ) ) scroll.showPopover()

			const space = this.Group_space().dom_tree() as HTMLElement
			this._group_space_dom = space
			this.apply_dom_style( space, {
				width: content_width + 'px',
				height: content_height + 'px',
				flexShrink: '0',
			} )

			const fill = this.Group_fill().dom_tree() as HTMLElement
			this._group_fill_dom = fill
			this.apply_dom_style( fill, {
				position: 'fixed',
				inset: 'auto',
				left: shift_left - this.group_scroll_left() + 'px',
				top: shift_top - this.group_scroll_top() + 'px',
				width: root_width + 'px',
				height: root_height + 'px',
				margin: '0',
				padding: '0',
				borderColor: this.widget_border_color_style( widget ),
				borderWidth: this.widget_border_width_px( widget ),
				borderStyle: this.widget_border_style( widget ),
				outline: 'none',
				transition: 'none',
				backgroundColor: this.widget_background_style( widget ) || 'transparent',
				pointerEvents: 'none',
			} )
			if( fill.popover !== 'manual' ) fill.popover = 'manual'
			if( !fill.matches( ':popover-open' ) ) fill.showPopover()
		}

		group_fullscreen_doms( id: string ) {
			const root = this.fullscreen_widget( id )
			const page = this.fullscreen_map_page( id )
			const root_left = this.widget_left( root )
			const root_top = this.widget_top( root )
			const zoom = this.fullscreen_zoom()
			const root_width = this.widget_width( root ) * zoom
			const root_height = this.widget_height( root ) * zoom
			const viewport_width = this.$.$mol_dom_context.window.innerWidth - this.fullscreen_panel_width()
			const shift_left = Math.max( 0, ( viewport_width - root_width ) / 2 )
			const shift_top = Math.max( 0, ( this.$.$mol_dom_context.window.innerHeight - root_height ) / 2 )
			const scroll_left = this.group_scroll_left()
			const scroll_top = this.group_scroll_top()

			const widgets = this.group_child_widgets( root )
			return widgets.map( widget => {
				const view = page.Widget( widget.link() ).Sub()
				const dom = view.Content_scroll().dom_tree() as HTMLElement
				const container = this.widget_has_fullscreen_children( widget )

				const style: Record< string, string > = {
					position: 'fixed',
					inset: 'auto',
					left: shift_left + ( this.widget_left( widget ) - root_left ) * zoom - scroll_left + 'px',
					top: shift_top + ( this.widget_top( widget ) - root_top ) * zoom - scroll_top + 'px',
					width: this.widget_width( widget ) * zoom + 'px',
					height: this.widget_height( widget ) * zoom + 'px',
					margin: '0',
					border: 'none',
					outline: 'none',
					transition: 'none',
					userSelect: 'text',
					color: widget.color() || 'var(--mol_theme_text)',
				}

				if( container ) {
					style.borderColor = this.widget_border_color_style( widget )
					style.borderWidth = this.widget_border_width_px( widget )
					style.borderStyle = this.widget_border_style( widget )
					style.backgroundColor = this.widget_background_style( widget ) || 'transparent'
				}

				this.apply_dom_style( dom, style )
				this.apply_content_zoom( dom )

				this.bind_group_scroll_wheel( dom )
				return dom
			} )
		}

		@ $mol_mem
		group_scroll_pos( next?: readonly [ number, number ] ) {
			return next ?? [ 0, 0 ]
		}

		group_scroll_left() {
			return this.group_scroll_pos()[0]
		}

		group_scroll_top() {
			return this.group_scroll_pos()[1]
		}

		group_scroll( event?: Event | null ) {
			const scroll = event?.target as HTMLElement | undefined
			if( scroll ) this.group_scroll_pos( [ scroll.scrollLeft, scroll.scrollTop ] )
			return event ?? null
		}

		bind_group_scroll_wheel( dom: HTMLElement ) {
			if( this._group_wheel_doms.has( dom ) ) return

			const handler = ( event: WheelEvent )=> {
				if( event.defaultPrevented || event.ctrlKey ) return
				if( this.event_target_can_scroll( event.target as Element, dom, event.deltaX, event.deltaY ) ) return

				const scroll = this._group_scroll_dom
				if( !scroll ) return

				scroll.scrollLeft += event.deltaX
				scroll.scrollTop += event.deltaY
				this.group_scroll_pos( [ scroll.scrollLeft, scroll.scrollTop ] )
				event.preventDefault()
			}

			dom.addEventListener( 'wheel', handler, { passive: false } )
			this._group_wheel_doms.add( dom )
			this._group_wheel_disposers.push( ()=> dom.removeEventListener( 'wheel', handler ) )
		}

		event_target_can_scroll( target: Element | null, root: Element, delta_x: number, delta_y: number ) {
			for( let node = target; node; node = node.parentElement ) {
				const style = getComputedStyle( node )
				const can_y = /(auto|scroll)/.test( style.overflowY )
					&& node.scrollHeight > node.clientHeight
					&& ( delta_y < 0 ? node.scrollTop > 0 : node.scrollTop + node.clientHeight < node.scrollHeight )
				const can_x = /(auto|scroll)/.test( style.overflowX )
					&& node.scrollWidth > node.clientWidth
					&& ( delta_x < 0 ? node.scrollLeft > 0 : node.scrollLeft + node.clientWidth < node.scrollWidth )

				if( can_y || can_x ) return true
				if( node === root ) break
			}

			return false
		}

		widget_has_fullscreen_children( widget: $shm_hitalama_map_widget ) {
			return [ 'group', 'layout_vert', 'layout_hor', 'notebook2' ].includes( widget.type() )
		}

		group_child_widgets( root: $shm_hitalama_map_widget ): $shm_hitalama_map_widget[] {
			return root.widgets()
				.slice()
				.sort( ( left, right )=> left.z() - right.z() )
				.flatMap( widget => this.widget_has_fullscreen_children( widget ) ? [ widget, ... this.group_child_widgets( widget ) ] : [ widget ] )
		}

		apply_content_zoom( dom: HTMLElement ) {
			const content = dom.firstElementChild as HTMLElement | null
			if( !content ) return

			const zoom = this.fullscreen_zoom()
			const extent = `${ 100 / zoom }%`
			this._fullscreen_zoom_doms.add( content )
			this.apply_dom_style( content, {
				zoom: '1',
				transformOrigin: '0 0',
				transform: `scale(${ zoom })`,
				width: extent,
				minWidth: extent,
				minHeight: extent,
			} )
		}

		restore_content_zoom() {
			for( const dom of this._fullscreen_zoom_doms ) this.restore_dom_style( dom )
			this._fullscreen_zoom_doms.clear()
		}

		apply_dom_style( dom: HTMLElement, style: Record< string, string > ) {
			let backup = this._fullscreen_style_backup.get( dom )
			if( !backup ) {
				backup = {}
				this._fullscreen_style_backup.set( dom, backup )
			}

			for( const key of Object.keys( style ) ) {
				if( backup[ key ] === undefined ) backup[ key ] = ( dom.style as any )[ key ] ?? ''
				;( dom.style as any )[ key ] = style[ key ]
			}
		}

		restore_dom_style( dom: HTMLElement ) {
			const backup = this._fullscreen_style_backup.get( dom )
			if( !backup ) return

			for( const key of Object.keys( backup ) ) {
				dom.style.removeProperty( this.style_property_name( key ) )
				;( dom.style as any )[ key ] = backup[ key ]
			}

			this._fullscreen_style_backup.delete( dom )
		}

		widget_background_style( widget: $shm_hitalama_map_widget ): string {
			const color = widget.background_color()
			if( !color || color == 'transparent' ) return color

			return this.widget_color_with_opacity( color, widget.background_opacity() )
		}

		widget_border_color_style( widget: $shm_hitalama_map_widget ): string {
			if( widget.border_width() <= 0 ) return ''

			return this.widget_color_with_opacity(
				widget.border_color(),
				widget.border_opacity(),
			)
		}

		widget_border_width_px( widget: $shm_hitalama_map_widget ): string {
			const width = Math.max( 0, widget.border_width() )
			if( width === 0 ) return ''

			return `${ width }px`
		}

		widget_border_style( widget: $shm_hitalama_map_widget ): string {
			if( widget.border_width() <= 0 ) return ''

			return widget.border_style()
		}

		widget_color_with_opacity( color: string, opacity: number ): string {
			if( !color || color == 'transparent' ) return color

			opacity = Math.max( 0, Math.min( 1, opacity ) )
			const match = color.match( /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i )
			if( !match ) return color

			const [ , red, green, blue ] = match
			return `rgba(${ parseInt( red, 16 ) }, ${ parseInt( green, 16 ) }, ${ parseInt( blue, 16 ) }, ${ opacity })`
		}

		widget_top( widget: $shm_hitalama_map_widget ) {
			return widget.body_y()
		}

		widget_left( widget: $shm_hitalama_map_widget ) {
			return widget.body_x()
		}

		widget_width( widget: $shm_hitalama_map_widget ) {
			return widget.right_edge_x()
		}

		widget_height( widget: $shm_hitalama_map_widget ) {
			return widget.bottom_edge_y()
		}

		@ $mol_mem
		fullscreen_ids( next?: string[] ) {
			$mol_wire_solid()
			return next ?? []
		}

		fullscreens() {
			$mol_wire_solid()
			return this.fullscreen_ids()
				.filter( id => this.fullscreen_needs_dom_slot( id ) )
				.map( id => this.fullscreen_content( id ) )
		}

		fullscreen_needs_dom_slot( id: string ) {
			const map_id = this.fullscreen_map( id ).link().toString()
			return map_id !== this.$.$mol_state_arg.value( 'map' )
				&& map_id !== this.$.$mol_state_arg.value( 'projects_map' )
		}

		@ $mol_mem_key
		fullscreen_map( id: string ) {
			const ref = new $giper_baza_link( id )
			const widget = this.$.$giper_baza_glob.Pawn( ref, $shm_hitalama_map_widget )
			return widget.map() ?? this.$.$giper_baza_glob.Pawn( ref.lord(), $shm_hitalama_map )
		}

		@ $mol_mem_key
		fullscreen_map_book( id: string ) {
			const map = this.fullscreen_map( id )
			const map_id = map.link().toString()

			if( map_id === this.$.$mol_state_arg.value( 'map' ) ) return this.map_book()
			if( map_id === this.$.$mol_state_arg.value( 'projects_map' ) ) {
				const projects = this.$.$shm_hitalama_app.Root( 0 ).Projects()
				if( projects.projects_map_id() === map_id ) return projects.Pinned_map_book()
			}

			const Map = new $shm_hitalama_map_book
			Map.entity = ()=> map
			return Map
		}

		@ $mol_mem_key
		fullscreen_widget( id: string ) {
			const ref = new $giper_baza_link( id )
			return this.$.$giper_baza_glob.Pawn( ref, $shm_hitalama_map_widget )
		}

		@ $mol_mem_key
		fullscreen_map_page( id: string ) {
			return this.fullscreen_map_book( id ).Map_page()
		}

		@ $mol_mem_key
		fullscreen_content_view( id: string ) {
			const ref = new $giper_baza_link( id )
			const Map = this.fullscreen_map_book( id )
			return Map.Widget( ref ).Sub().Content_scroll()
		}

		@ $mol_mem_key
		fullscreen_style( id: string ) {
			const opened = this.$.$mol_state_arg.value( 'widget' ) || this.$.$mol_state_arg.value( 'fullscreen_widget' )
			return {
				display: opened == id ? 'block' : 'none',
			}
		}

		@ $mol_mem_key
		fullscreen_content( id: string ) {
			$mol_wire_solid()

			const content = this.fullscreen_content_view( id )
			const base_style = content.style.bind( content )
			content.style = ()=> {
				const style = base_style()
				// The same view is reused on its map after a quick-access opening.
				// Explicitly clear overlay-only inline styles when it returns there.
				return this.fullscreen_needs_dom_slot( id )
					? { ... style, ... this.fullscreen_style( id ), userSelect: 'text' }
					: { ... style, display: style.display ?? '', userSelect: style.userSelect ?? '' }
			}

			return content
		}

		display() {
			return this.$.$mol_state_arg.value( 'fullscreen_widget' ) || this.application_id() ? 'block' : 'none'
		}

		application_id() { return this.$.$mol_state_arg.value( 'fullscreen_application' ) ?? '' }

		application_visible() {
			return this.application_id() && !this.$.$mol_state_arg.value( 'fullscreen_widget' ) ? [ this.Application() ] : []
		}

	}

}
